export default __webpack_public_path__ + "static/underline-witb-mobile-b3e564f8aedd46dbfa32539043b95d57.svg";